import { createSelector, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IToast } from '@/types';
import { ICourier } from '@/types/settings';
export interface ICommonState {
  toast: IToast;
  listCourier: Array<ICourier>;
  haveClosedPopup: boolean | 'first-time';
  permanentDismissIds: Array<string>;
  dismissIds: Array<string>;
  dismissIdsCount: { [key: string]: number };
  shouldOpenTrakowAssistant: boolean;
}

const toast: IToast = {
  hasAction: undefined,
  error: false,
  content: '',
  isOpen: false,
  contentAction: 'undo',
  onAction: () => {},
};

// Define the initial state using that type
const initialState: ICommonState = {
  toast: toast,
  listCourier: [],
  haveClosedPopup: 'first-time',
  permanentDismissIds: [],
  dismissIds: [],
  dismissIdsCount: {},
  shouldOpenTrakowAssistant: false,
};

const getInitialState = (): ICommonState => {
  return {
    ...initialState,
  };
};

export const commonSlice = createSlice({
  name: 'common',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: getInitialState(),
  reducers: {
    handleToast: (state, action: PayloadAction<IToast>) => {
      state.toast = action.payload;
    },
    handleListCourier: (state, action: PayloadAction<Array<ICourier>>) => {
      state.listCourier = action.payload;
    },
    handleClosePopup: (state, action: PayloadAction<boolean>) => {
      state.haveClosedPopup = action.payload;
    },
    setPermanentDismissId: (state, action: PayloadAction<string>) => {
      const existId = state.permanentDismissIds.find((id) => id === action.payload);
      if (!existId) {
        state.permanentDismissIds.push(action.payload);
      }
    },
    setDismissId: (state, action: PayloadAction<string>) => {
      const existId = state.dismissIds.find((id) => id === action.payload);
      if (!existId) {
        state.dismissIds.push(action.payload);
      }
    },
    increaseDismissIdCount: (state, action: PayloadAction<string>) => {
      state.dismissIdsCount[action.payload] = (state.dismissIdsCount[action.payload] || 0) + 1;
    },
    setShouldOpenTrakowAssistant: (state, action: PayloadAction<boolean>) => {
      state.shouldOpenTrakowAssistant = action.payload;
    },
    resetState() {
      return { ...getInitialState() };
    },
  },
});

export const { handleToast, setPermanentDismissId } = commonSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const toastSelector = createSelector(
  (state: RootState) => state.common,
  (state) => state.toast,
);
export const listCourierSelector = createSelector(
  (state: RootState) => state.common,
  (state) => state.listCourier,
);
export const haveClosedPopupSelector = createSelector(
  (state: RootState) => state.common,
  (state) => state.haveClosedPopup,
);
export const permanentDismissIdsSelector = createSelector(
  (state: RootState) => state.common,
  (state) => state.permanentDismissIds,
);
export const shouldOpenTrakowAssistantSelector = createSelector(
  (state: RootState) => state.common,
  (state) => state.shouldOpenTrakowAssistant,
);

export default commonSlice;
